import {Chip} from '@mui/material';

interface Props {
    label: string;
    backColor?: string;
    fontColor?: string;
    isOutlined?: boolean;
}

export default function CustomChip ({label, backColor, fontColor, isOutlined}:Props){
    return (<Chip label={label}
                  variant={!!isOutlined ? "outlined" : "filled"}
                  style={{backgroundColor: !!isOutlined ? "white" : (backColor ?? 'lightgray'),
                          borderColor: (backColor ?? "#000000"),
                          color: fontColor ?? '#000000'}}
        />);
}